import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ParameterBase, ParameterFormField } from '@app/shared/models/parameter';
import { FormConstructionService } from '@app/modules/parameters/services';
import { ParametersFactoryService } from '@app/core/services/parameters-factory';

@Component({
  selector: 'app-params-table',
  templateUrl: './params-table.component.html',
  styleUrls: ['./params-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ParamsTableComponent implements OnInit, OnDestroy, OnChanges {
  @Input() public fields: ParameterBase[];
  @Input() public form: UntypedFormGroup;
  @Input() public fieldName: string;

  public subForm: UntypedFormGroup = new UntypedFormGroup({});
  public subFormFields: ParameterFormField[] = [];
  private fieldQuantityPerPalletIndex: number;

  constructor(private paramsFieldService: FormConstructionService, private parametersFactoryService: ParametersFactoryService) {}

  public ngOnInit(): void {
    if (this.fields) {
      this.rebuildForm();
    }

   this.parametersFactoryService.palletQuantitySubject$.subscribe((palletQty) => {
      this.updateBobbinMaxLimit();
    });

    this.parametersFactoryService.bobbinQuantitySubject$.subscribe(() => {
      this.updateBobbinMaxLimit();
    });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.fields) {
      this.fields = changes.fields.currentValue;
      this.rebuildForm();
    }
  }

  public ngOnDestroy(): void {
    this.form.removeControl(this.fieldName);
  }

  public getSubFormFields(): ParameterFormField[] {
    return Object.entries(this.subForm.controls)
      .map<ParameterFormField>(([key, control]) => {
        const parameter = this.fields.find((field) => String(field.id) === key);
        return {
          parameter,
          control: control as UntypedFormControl
        };
      })
      .sort((a, b) => a.parameter.order - b.parameter.order);
  }

  public trackByFunction(index: number, field: ParameterFormField): number {
    return field.parameter.id;
  }

  private updateBobbinMaxLimit(): void {
    const value = this.subFormFields[this.fieldQuantityPerPalletIndex]?.control?.value;

    const validators = [];
    validators.push(Validators.required);
    validators.push(Validators.min(1));
    validators.push(Validators.max(value));

    const controlToUpdate = this.subForm.get('1'); // bobbin qty control
    if (controlToUpdate) {
      controlToUpdate.setValidators(validators);
      controlToUpdate.updateValueAndValidity();
    }
  }

  private rebuildForm(): void {
    if (this.form && this.fieldName) {
      this.form.removeControl(this.fieldName);
    }

    this.subForm = this.paramsFieldService.toFormGroup(this.fields);
    this.subFormFields = this.getSubFormFields();

    if (this.form) {
      this.form.addControl(this.fieldName, this.subForm);
    }

    this.fieldQuantityPerPalletIndex = this.subFormFields.findIndex((field) => field.parameter.controlType === 'PalletQuantity');
    this.updateBobbinMaxLimit();
  }
}
